import React from "react";

const SharedDialogSelectorContext = React.createContext();

export default SharedDialogSelectorContext;